import React, { useState, useEffect } from "react";
 
const CountdownTimer  = ({ minutes }) => {
  const [timeLeft, setTimeLeft] = useState(minutes * 60); // تبدیل دقیقه به ثانیه

  useEffect(() => {
    // شروع شمارش معکوس
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 0) {
          clearInterval(timer);
          return 0; // اطمینان از توقف شمارش
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // پاکسازی تایمر در هنگام خروج از کامپوننت
  }, []);

  // محاسبه ساعت، دقیقه و ثانیه از زمان باقی‌مانده
  const hours = Math.floor(timeLeft / 3600);
  const minutesLeft = Math.floor((timeLeft % 3600) / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="countdown-timer">
      <h6 className="text-danger">
        {hours.toString().padStart(2, "0")}:
        {minutesLeft.toString().padStart(2, "0")}:
        {seconds.toString().padStart(2, "0")}
      </h6>
    </div>
  );
};

export default CountdownTimer;
